import React from 'react'
import { Link } from 'react-router-dom'

const Logo = () => {
    return (
        <div className='logo'>
            <Link to='/' className='gtm-site-logo-click'>
                <img src='/images/exetel-logo.svg' alt='Exetel' />
            </Link>
        </div>
    )
}

export default Logo



// WEBPACK FOOTER //
// ./resources/js/components/Logo.js